// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"9fba6162","287":"9d83b72e","775":"ee056ecd","914":"9fba6162"}[chunkId] + ".chunk.css";
};